<template>

  <v-card>

    <v-toolbar
      card
      dense
      color="transperent"
    >
      <v-btn
        icon
        @click.native="saveAndClose"
      >
        <v-icon>library_add</v-icon>
      </v-btn>
      <v-btn
        icon
        @click.native="save"
        :loading="subtaskloader"
      >
        <v-icon>save</v-icon>
      </v-btn>
      <v-btn
        icon
        @click.native="deleterow"
        :loading="subtaskloader"
      >
        <v-icon>delete</v-icon>
      </v-btn>
      <v-spacer></v-spacer>

      <v-dialog
        v-model="subdialog"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <sub-task ref="refsubTaskForm"></sub-task>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              outline
              @click.native="subdialog = false"
            >Cancel</v-btn>
            <v-btn
              color="primary darken-1"
              outline
              @click.native="saveSubTask"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="taskdialog"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <task-form ref="refTaskForm"></task-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              outline
              @click.native="taskdialog = false"
            >Cancel</v-btn>
            <v-btn
              color="primary darken-1"
              outline
              @click.native="saveMainTask"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- <v-btn
        icon
        @click.native="taskDuplicateClick"
        v-if="actionButton"
      >
        <v-icon icon>mdi-anchor</v-icon>
      </v-btn>
      <v-btn
        icon
        @click.native="taskLinkClick"
        v-if="actionButton"
      >
        <v-icon icon>link</v-icon>
      </v-btn> -->
      <v-btn
        icon=""
        @click="addMainTask()"
      >
        <v-icon icon>
          note_add
        </v-icon>
      </v-btn>
      <v-btn
        icon=""
        @click="addSubTask()"
      >
        <v-icon icon>
          add_circle_outline
        </v-icon>
      </v-btn>
      <v-btn
        icon=""
        @click="goBack"
      >
        <v-icon icon>
          reply
        </v-icon>
      </v-btn>
    </v-toolbar>

    <v-layout
      justify-space-between
      pa-3
    >

      <app-section-loader :status="subtaskloader"></app-section-loader>

      <v-flex xs3>
        <vue-perfect-scrollbar
          class="chat-room--scrollbar grey lighten-5"
          v-bind:style="computeHeight"
        >
          <v-treeview
            :active.sync="active"
            :items="items"
            :open.sync="open"
            activatable
            active-class="primary--text"
            transition
            v-model="selectedTask"
            :open-all="true"
            class="grey lighten-5"
          >

          </v-treeview>
        </vue-perfect-scrollbar>
      </v-flex>

      <v-flex
        v-if="selected"
        d-flex
        xs9
      >
        <task-tabform></task-tabform>
      </v-flex>
      <v-flex
        v-else
        d-flex
        xs9
      >
      </v-flex>
    </v-layout>

  </v-card>

</template>
<script>
import router from 'vue-router';
import SubTask from '@/pages/task/subtask';
import TaskForm from '@/pages/task/subtask';
import TaskTabform from '@/pages/task/taskTap';
import { getSubTasksId, getTaskTreeId, getTaskMastersbyID, getuserTaskTreeId, updateRead } from '@/api/taskMaster';
export default {
  components: {
    TaskTabform,
    SubTask,
    TaskForm
  },

  name: 'Page2',
  data: () => ({

    subdialog: false,
    taskdialog: false,
    active: [],
    avatar: null,
    open: [],
    users: [],
    taskItems: [],
    taskAllItems: [],
    subTaskitems: [],
    taskLinkDialog: false,
    actionButton: false,
    taskDuplicateDialog: false,
    subTaskDialog: false,
    taskID: -1,
    formTitle: 'Task Details',
    mergeTask: {      taskMergedIds: [],
      modifiedByUserID: null    },
    panel: [],
    formEditdata: {
      valid: false,
      taskID: -1,
      date: new Date(),
      title: '',
      assignedTo: null,
      dueDate: new Date(),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date(),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
      mainTaskId: null,
      taskLinkedIds: [],
    },
    subtaskloader: false,
    subtasktriggered: false,
    selectedTask: [],
  }),
  created () {
    window.getApp.$on('EDIT_TASK', item => {
    });

    this.taskID = this.$route.params.id;
    this.actionButton = true;
    this.initialize();
    // window.getApp.$on('INITIALIZE_SUBTASK', taskID => {
    //   this.taskID = taskID;
    //   this.initialize();
    // });
    window.getApp.$on('SEND_TASKOBJ', objTask => {
      this.formEditdata = objTask;
    });
  },
  beforeDestroy () {

    window.getApp.$off('INITIALIZE_TASK')
    window.getApp.$off('EDIT_TASK')
    window.getApp.$off('INITIALIZE_TASKFILE')
    window.getApp.$off('INITIALIZE_TASKCONVER')
    window.getApp.$off('INITIALIZE_SUBTASK')
    window.getApp.$off('EDIT_SUBTASK')
    window.getApp.$off('ADD_SUBTASK')
    window.getApp.$off('SAVE_SUBTASK')
    window.getApp.$off('ADD_MAINSUBTASK')
    window.getApp.$off('SEND_TASKOBJ')
  },
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    },
    selected () {

      if (!this.active.length) {
        if (this.taskID > 0) {
          this.active.push(this.taskID);
        }
        else {
          return undefined
        }
      }

      const id = this.active[0]
      let editdata = this.taskItems.find(task => task.taskID == id);
      this.formEditdata = editdata;
      window.getApp.$emit('DISABLE_TAB', false);
      window.getApp.$emit('EDIT_TASK', editdata);
      updateRead(id)
        .then(response => {

        })
        .catch(error => {
          this.subtaskloader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      return editdata;
    },
    items () {
      return this.subTaskitems;
    },
  },

  watch: {

  },

  methods: {
    initialize () {
      if (this.taskID > 0) {

        this.subtaskloader = true;
        let userId = this.$store.state.auth.userId;
        getTaskTreeId(this.taskID, userId)
          .then(response3 => {
            this.subTaskitems = response3.data;
            this.subtaskloader = false;

          })
          .catch(error => {
            this.subtaskloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });

        getSubTasksId(this.taskID, userId)
          .then(response3 => {
            this.taskItems = response3.data;
            this.subtaskloader = false;

          })
          .catch(error => {
            this.subtaskloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });

      }
      else {
        this.subTaskitems = [];
      }
    },
    saveAndClose () {
      this.save();
      this.close();
      this.editedItem = this.defaultItem;
    },
    save () {

      window.getApp.$emit('SAVE_TASK');


    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    taskLinkClick () {

      this.taskLinkDialog = true;

      this.taskDuplicateDialog = false;
    },
    taskDuplicateClick () {

      this.taskDuplicateDialog = true;
      this.taskLinkDialog = false;
    },
    taskDuplicatesave () {

      // if (this.form.validate()) {
      this.subtaskloader = true;
      this.mergeTask.modifiedByUserID = this.$store.state.auth.userId;

      let index = this.editedIndex;
      //this.taskMergeIds = this.editedItem.taskMergeIds;     
      //console.log(this.taskMergeIds);

      duplicateTask(this.mergeTask)
        .then(response => {

          window.getApp.$emit('APP_API_SUCCESS', "Duplicate Task Saved.... ");
          this.taskDuplicateDialog = false;
        })
        .catch(error => {
          this.subtaskloader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.initialize();
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;

        // window.getApp.$off('EDIT_TASK')
        // window.getApp.$off('INITIALIZE_TASKFILE')
        // window.getApp.$off('INITIALIZE_TASKCONVER')
        // window.getApp.$off('INITIALIZE_SUBTASK')
        // window.getApp.$off('SEND_TASKOBJ')

      }, 400);
    },
    addMainTask () {
      this.formTitle = 'Add Main Task';
      // setTimeout(() => {
      //   window.getApp.$emit('SEND_TASKOBJ', this.formEditdata);
      //   window.getApp.$emit('ADD_MAINSUBTASK', this.formEditdata);
      // }, 300);

      this.$refs.refTaskForm.initialize();
      this.$refs.refTaskForm.formdata.addedByUser = this.$store.state.auth.userName;
      this.$refs.refTaskForm.formdata.dueDate = this.formateDate(this.formEditdata.dueDate);
      this.$refs.refTaskForm.parentTaskID = this.formEditdata.taskID;
      this.$refs.refTaskForm.mainTaskId = this.formEditdata.mainTaskId;

      this.taskdialog = true;
    },
    editSubTask () {
      setTimeout(() => {
        window.getApp.$emit('SEND_TASKOBJ', this.formEditdata);
        window.getApp.$emit('EDIT_SUBTASK', this.formEditdata);
      }, 300);

      this.$refs.refsubTaskForm.initialize();
      this.$refs.refsubTaskForm.formdata.addedByUser = this.$store.state.auth.userName;
      this.$refs.refsubTaskForm.formdata.dueDate = this.formateDate(this.formEditdata.dueDate);
      this.$refs.refsubTaskForm.parentTaskID = this.formEditdata.taskID;
      this.$refs.refsubTaskForm.mainTaskId = this.formEditdata.mainTaskId;

      this.subdialog = true;
    },
    addSubTask () {
      this.formTitle = 'Add Sub Task';
      // setTimeout(() => {
      //   window.getApp.$emit('SEND_TASKOBJ', this.formEditdata);
      //   window.getApp.$emit('ADD_SUBTASK', this.formEditdata);
      // }, 300);

      this.$refs.refsubTaskForm.initialize();
      this.$refs.refsubTaskForm.formdata.addedByUser = this.$store.state.auth.userName;
      this.$refs.refsubTaskForm.formdata.dueDate = this.formateDate(this.formEditdata.dueDate);
      this.$refs.refsubTaskForm.parentTaskID = this.formEditdata.taskID;
      this.$refs.refsubTaskForm.mainTaskId = this.formEditdata.mainTaskId;

      this.subdialog = true;
    },
    saveSubTask () {
      this.subtasktriggered = false;
      window.getApp.$emit('SAVE_SUBTASK', this.taskID);
    },
    saveMainTask () {
      //alert('save main task');
      this.subtasktriggered = false;
      window.getApp.$emit('SAVE_SUBTASK', null);
    },
    goBack () {
      this.$router.push({ name: 'Task' });
    },
    formateDate (string) {
      return string ? new Date(string).toISOString().substr(0, 10) : '';
    },
  }
}
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>


// WEBPACK FOOTER //
// src/pages/task/taskformdetails.vue